<template>
  <div id="app">
	  <keep-alive>
    	<router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"/>
	  </keep-alive>
	  <router-view v-if="!$route.meta.keepAlive"></router-view>
	  <n-toast ref="nToast"/>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
	name: 'App',
	mounted() { 
		Vue.prototype.$nToast = this.$refs.nToast
	}
}
</script>

<style lang="less">
.dibugg {
	z-index: 999 !important;
}
.ad {
	display: block;
	width: 100%;
	img {
		display: block;
		width: 100%;
	}
}

.red {
	color: red;
}

.line-clamp-1 {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/App.vue